export const selectHasActivePlan = (state) => {
  const plans =
    state && state.plan && Array.isArray(state.plan.data) ? state.plan.data : [];
  return plans.some((plan) => plan && plan.isActive);
};
